import { mapEnumToOptions } from '@abp/ng.core';

export enum NotificationActionType {
  Creator_FanDonate = 0,
  Creator_DonateAllAndWaitConfirm = 1,
  Creator_BuyAndShipped = 2,
  Creator_NotConfirmIn30Days = 3,
  Creator_PriceIncrease = 4,
  Fan_PriceIncrease = 5,
  Creator_FanFollow = 6,
  Fan_CreatorAddGift = 7,
  RefundToFanSuccess = 8,
  SendNotificationWhenGiftAfter60DaysFromFirstDonate = 9,
  OutOfStock = 10,
  ImportWishlistSomeItemsHasErrorsDueToOutOfStockOrMissingIF = 11,
  ImportWishlistSucces = 12,
  RefundToFanFail = 13,
  InProgressImportWishlist = 14,
  Creator_ShipFeeIncrease = 15,
  Fan_ShipFeeIncrease = 16,
  ImportWishlistSomeItemsHasErrorDueToErrorConnectingToAmazone = 17,
  ImportWishlistSomeItemsHasErrors = 18,
  OutOfStockChangeByGiPTStaff = 19,
  Creator_CancelByGiPTStaffWithNoReason = 20,
  Creator_PriceDecrease = 21,
  Creator_FanRequestFollow = 22,
  Fan_CreatorConfirmFollow = 23,
  Fan_CreatorRejectFollow = 24,
  Fan_CreatorGiftDelivered = 25,
  Creator_GiftConfirmDelivered = 26,
}

export const notificationActionTypeOptions = mapEnumToOptions(NotificationActionType);
